import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IPortalOrderFilterProps } from '@apps-common/stores'
import { IOrderListModel } from '@apps-common/types/portal/order'

export const QUERY_SEARCH_ORDERS = (
  companyId?: string,
  orderNo?: string,
  startDate?: string | null,
  endDate?: string | null,
  status?: string,
  skip?: number,
  take?: number
) => ['searchOrders', companyId, orderNo, startDate, endDate, status, skip, take].filter(Boolean)

export const searchOrders = async (
  companyId: string,
  orderNo: string,
  startDate: string | null,
  endDate: string | null,
  status: string,
  skip: number,
  take: number
): Promise<IOrderListModel[]> =>
  axios
    .get(
      `/Order/Orders?companyId=${companyId}&orderNo=${orderNo}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}&status=${status}&skip=${skip}&take=${take}`
    )
    .then((res) => res.data?.data)

type QueryFnType = typeof searchOrders

type Props = {
  config?: QueryConfig<QueryFnType>
  model: IPortalOrderFilterProps
}

export const useSearchOrders = ({ config, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_SEARCH_ORDERS(model.companyId, model.orderNo, model.startDate, model.endDate, model.status, model.skip, model.take),
    queryFn: () => searchOrders(model.companyId, model.orderNo, model.startDate, model.endDate, model.status, model.skip, model.take)
  })
